import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import NavHeaderSm from "./header-sm.vue";
import NavHeaderLg from "./header-lg.vue";
import { onMounted, onUnmounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationHeader',
  setup(__props) {

const isMobile = ref(false);

const checkDeviceType = () => {
  isMobile.value = window.matchMedia("(max-width: 768px)").matches;
};

onMounted(() => {
  checkDeviceType();
  window.addEventListener("resize", checkDeviceType);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkDeviceType);
});

return (_ctx: any,_cache: any) => {
  return (!isMobile.value)
    ? (_openBlock(), _createBlock(NavHeaderLg, { key: 0 }))
    : (_openBlock(), _createBlock(NavHeaderSm, { key: 1 }))
}
}

})